@if (agreement) {
  <app-agreement-card [showAttachmentsList]="!isAffiliateContract" [agreement]="agreement">
    <div top-buttons class="d-flex flex-row justify-content-end align-items-baseline mt-3 mb-5 w-100">
      @if (agreement.needsCheck) {
        <app-pascom-checkbox [inputId]="'b1'" [text]="isAffiliateContract ? ('agreement_accept_contract' | i18next) : ('agreement_accept_ack' | i18next)" [accepted]="accepted" (acceptChanged)="accept($event)"></app-pascom-checkbox>
      }
      <button class="btn btn-outline-primary ml-3" type="button" (click)="continue()" [disabled]="agreement.needsCheck && !accepted">{{'app_continue' | i18next}} </button>
    </div>
    <div bottom-buttons class="d-flex flex-row justify-content-end align-items-baseline mt-5">
      @if (agreement.needsCheck) {
        <app-pascom-checkbox [inputId]="'b2'" [text]="isAffiliateContract ? ('agreement_accept_contract' | i18next) : ('agreement_accept_ack' | i18next)" [accepted]="accepted" (acceptChanged)="accept($event)"></app-pascom-checkbox>
      }
      <button class="btn btn-outline-primary ml-3" type="button" (click)="continue()" [disabled]="agreement.needsCheck && !accepted">{{'app_continue' | i18next}} </button>
    </div>
  </app-agreement-card>
}
